<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1">饼状图</el-radio>
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <div class="timesheet" style="padding:20px">
        <div class="block">
          <el-date-picker
            v-model="value2"
            type="datetimerange"
            align="right"
            format="yyyy-MM-dd hh:mm:ss"
            value-format="yyyy-MM-dd hh:mm:ss"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
          <el-button type="primary" @click="clickBtn()">查询</el-button>
        </div>
      </div>
      <div ref="modularChild3" class="echarts"></div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import * as echarts from "echarts"
export default {
  name: 'modularChild3',
  props: ['socUserName'],    
  data() {
    return {
      value1: '',
      value2: [],
      radio: 1,
      chartsi: null,
      chartLoading: false,
      optioni: {
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          left: "center",
          top: "top",
          // orient: "vertical",
          // data: ["直接访问", "邮件营销", "联盟广告", "视频广告", "搜索引擎"]
        },
        series: [
          {
            name: "告警类型分布",
            type: "pie",
            radius: ["50%", "70%"],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: "center"
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "20",
                fontWeight: "bold"
              }
            },
            labelLine: {
              show: false
            },
            data: []
          }
        ]
      },
    endTime: "",
    username: "",
    startTime: ""            
    };
  },
  methods: {
    getTime(socUserName){
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true;      
      var nowdate = new Date();
      var startTime = nowdate.setMonth(nowdate.getMonth()-1); 
      var endTime = Date.parse(new Date());
      let params = {
        "endTime": endTime,
        "username": socUserName,
        "startTime": startTime
      }
      this.getData(params)
    },
    clickBtn(socUserName) {     
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true; 
      let params = {
        'endTime': this.value2 ? Date.parse(this.value2[1]) : '',
        'username': socUserName,
        'startTime': this.value2 ? Date.parse(this.value2[0]) : ''
      }     
      this.getData(params)
    },
    getData(params) {
      this.$http.post(`/front/consumer/order/soc/interface/queryDistributionOfSecurityAlarmTypes`, params)
        .then(data => { 
          if (data && data.status === 200 && data.data.code === 0) {
            let res = this.formatterData(data.data.data)
            this.chartsi.setOption(res)
          } else {
            this.$message.error(data.result.msg)
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
    },
    formatterData(data) {
      // this.optioni.series[0].data = [
      //   { value: Math.floor(Math.random() * (100 - 1)) + 1, name: "命令控制" },
      //   { value: Math.floor(Math.random() * (100 - 1)) + 1, name: "规则模型" },
      //   { value: Math.floor(Math.random() * (100 - 1)) + 1, name: "内部侦查" },
      //   { value: Math.floor(Math.random() * (100 - 1)) + 1, name: "反弹shell" },
      //   { value: Math.floor(Math.random() * (100 - 1)) + 1, name: "SQL注入尝试" }
      // ]
      this.optioni.series[0].data = data
      return this.optioni
    }
  },
  mounted() {
    let charti = echarts.getInstanceByDom(this.$refs["modularChild3"]);
    if (charti === undefined) {
      this.chartsi = echarts.init(this.$refs["modularChild3"]);
      this.$once("hook:beforeDestroy", function() {
        echarts.dispose(this.chartsi);
      });
    }
    this.getTime();
  }
};
</script>

<style lang="scss" scoped>
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 100px;
      margin: 0 auto;
    }
  }
  .echarts {
    height: calc(100vh - 370px);
    min-height: 450px;
  }
}
</style>